import { type FC, type ReactNode } from 'react';
import { graphql, useFragment } from 'react-relay';
import classnames from 'classnames';

import dibsCss from 'dibs-css';
import styles from './SharedBottomModuleSpacer.scss';

import { type SharedBottomModuleSpacer_bottomModule$key } from './__generated__/SharedBottomModuleSpacer_bottomModule.graphql.ts';

const bottomModuleFragment = graphql`
    fragment SharedBottomModuleSpacer_bottomModule on BottomModule @relay(plural: true) {
        __typename
    }
`;

type Props = {
    bottomModule: SharedBottomModuleSpacer_bottomModule$key | null | undefined;
    className?: string;
    children: ReactNode;
};

export const SharedBottomModuleSpacer: FC<Props> = ({
    className,
    bottomModule: bottomModuleRef,
    children,
}) => {
    const bottomModule = useFragment(bottomModuleFragment, bottomModuleRef);

    if (!bottomModule || !bottomModule.length) {
        return null;
    }
    return (
        <div
            className={classnames(
                classnames(styles.wrapper, dibsCss.ptLarge, dibsCss.px0, dibsCss.pbSmall),
                className
            )}
        >
            {children}
        </div>
    );
};
